import React, { Component } from 'react';
import {NavLink, Link} from "react-router-dom";
import logo from '../Assets/logo.png';
import { name } from "../Constant";
import Footer from "../Components/footer";
import Button from "../Components/button";
import { RedirectNotLogin, UpdateState, getState, handleSubmit, BreedForm, AlertMessage, AlertMessageOut, serializeArray } from "../Components/function";

class ChangePassword extends Component{

  constructor(props){
    super(props);
    
    this.state = {
      oldpassword : '',
      password: '',
      password2: '',
      message: '',
      loading: '',
    }
    }
    
    componentDidMount(){
        RedirectNotLogin();
      }
  
      componentDidUpdate() {
        RedirectNotLogin();
      }
 
  render(){
    return (
        <div className="App">
      <div className="body-wrappers" id="body-wrapper">
        <div className="form-first-child"> </div>

        <div className="form-wrapper">
      <div className="form-wrap-login">
        <div className="logo-wrap">
          <div className="logo-inner-wrap">
          <NavLink to="/">
            <img className="logo" src={logo} title={name + " Logo"} alt={name + " Logo"}/>
            </NavLink>
          </div>
          </div>
      <div className="form-inner-wrap">
      <div className="h1s">Change Password</div>
       
       <BreedForm route="changepassword">

       {AlertMessageOut(this)}

       <div className="form-group-lg">   
      <input type="password" className="form-input" id="oldpassword" placeholder="Old Password" 
       onChange={(input) => UpdateState(this, "oldpassword", input.target.value) }/>
       </div>

       <div className="form-group-lg">   
      <input type="password" className="form-input" id="password" placeholder="New Password"
       onChange={(input) => UpdateState(this, "password", input.target.value) }/>
       </div>

       <div className="form-group-lg">   
      <input type="password" className="form-input" id="password2" placeholder="Confirm Password"
       onChange={(input) => UpdateState(this, "password2", input.target.value) }/>
       </div>
       
       <Button 
       wrapperClass="form-group-lg" 
       buttonClass="btn btn-blue btn-link" 
       buttonText="CHANGE PASSWORD"
       buttonAction="changepassword"
       self={this} />


         </BreedForm>
         <div className="form-group-lg">
         <NavLink to="/dashboard">
       Don't want to? Go to Dashboard
       </NavLink>
       </div> 

         </div>
        </div>
      </div>
      </div>

   

      <Footer/>
    </div>
    );
}

}

export default ChangePassword;